import { Card, Flex, ScrollArea } from "@mantine/core";
import { DatePicker } from "@mantine/dates";
import { DateTime } from "luxon";
import { CALENDAR_DATE_TYPES } from "../../../../constants/calendarConstants";
import { COLORS } from "../../../../constants/colorConstants";
import { useCalendarContext } from "../../../../contexts/CalendarContext";
import { getMonthsFromRange } from "../../../../utils/isoDateUtils";
import { getEntryById } from "../../../../utils/objectUtils";

export default function CalendarViewDatesCard() {
  const { singleFetch, calendarDatesFetch } = useCalendarContext();

  const startDate = DateTime.fromISO(singleFetch?.data?.startDate);
  const endDate = DateTime.fromISO(singleFetch?.data?.endDate);
  const months = getMonthsFromRange(startDate, endDate);
  const isoDates = calendarDatesFetch?.data?.map((item) => item.date) ?? [];

  return (
    <Card shadow="xs" p="md" radius="lg" mb="md" miw={300} maw={900} withBorder bg={COLORS.WHEAT} c={COLORS.DARK_BROWN}>
      <ScrollArea type="always" mah={600}>
        <Flex gap="xl" wrap="wrap">
          {months.map((month) => (
            <MonthlyCalendar startDate={month.startDate} endDate={month.endDate} value={isoDates} />
          ))}
        </Flex>
      </ScrollArea>
    </Card>
  );
}

function MonthlyCalendar({ startDate, endDate, value }) {
  return (
    <DatePicker
      type="multiple"
      static
      maxLevel="month"
      hideOutsideDates
      value={value}
      minDate={startDate}
      maxDate={endDate}
      defaultDate={startDate}
      getDayProps={getDayProps}
    />
  );
}

const getDayProps = (value) => {
  const { calendarDatesFetch } = useCalendarContext();
  const date = calendarDatesFetch?.data?.find((item) => item.date === value);

  if (date) {
    const dateType = getEntryById(CALENDAR_DATE_TYPES, date.type);

    return {
      title: dateType.label,
      style: {
        backgroundColor: dateType.color,
        borderRadius: "50%",
      },
    };
  }

  return {};
};
